import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// A new page starts at its top. A single-page app keeps the window's scroll position from one route to the
// next, and RouteAnnouncer focuses the new page's <h1> without scrolling, so a link followed from far down a
// page (a footer link, "Next in this situation" between two research answers) would open the next page part
// way down. On a link or a redirect to a new path the window goes to the top, also when the link names a
// #section (/pricing#credits opens a tab near the top; a CMS page scrolls to its section once its text has
// loaded, after this). Back and Forward (POP) are left to the browser's own scroll restoration.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const type = useNavigationType();
  const shown = useRef(pathname);

  useEffect(() => {
    if (shown.current === pathname) return;
    shown.current = pathname;
    if (type === "POP") return;
    window.scrollTo(0, 0);
  }, [pathname, type]);

  return null;
};

export default ScrollToTop;
